import { FormField, FormInput, FormSelect } from "web-design-system";
import { BELONGS_TO } from "creso-core/constants";
import { getFieldLabel } from "creso-core/utils";
import { Section } from "./section";
import { useAccountForm } from "./context";

export function ContactDetailsSection() {
  const { form, isEditing } = useAccountForm();

  const dirtyFields = Object.entries(form.formState.dirtyFields.contact || {})
    .filter(([, v]) => v)
    .map(([k]) => getFieldLabel(k));

  return (
    <Section title="Contact details" dirtyFields={dirtyFields}>
      <div className="grid gap-6 grid-cols-4">
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          name="contact.number"
          disabled
          render={({ field }) => <FormInput label="Mobile number" {...field} />}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          name="contact.phone_belongs_to"
          render={({ field }) => (
            <FormSelect
              label="Mobile number belongs to"
              options={BELONGS_TO}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          name="contact.email"
          disabled
          render={({ field }) => <FormInput label="Email" {...field} />}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          name="contact.email_belongs_to"
          render={({ field }) => (
            <FormSelect
              label="Email belongs to"
              options={BELONGS_TO}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
      </div>
    </Section>
  );
}
